<div class="p-6">
    <div class="flex items-center gap-3 mb-4">
        <div class="bg-rougeNovo rounded-lg w-10 h-10 flex items-center justify-center flex-shrink-0">
            <mat-icon class="material-symbols-outlined !text-[22px] !w-[22px] !h-[22px] !leading-[22px] text-white">drive_file_rename_outline</mat-icon>
        </div>
        <p class="text-white font-semibold text-lg m-0">
            {{ 'PACKAGES_PERSO_MANAGEMENT.PACKAGE_NAME_DIALOG_TITLE' | translate }}
        </p>
    </div>

    <p class="text-gray-300 text-sm mb-4">
        {{ 'PACKAGES_PERSO_MANAGEMENT.PACKAGE_NAME_DIALOG_DESCRIPTION' | translate }}
    </p>

    <label for="packageNameDialogInput" class="block text-sm font-semibold text-white mb-2">
        {{ 'PACKAGES_PERSO_MANAGEMENT.PACKAGE_NAME_LABEL' | translate }}
        <span class="required-badge">{{ 'PACKAGES_PERSO_MANAGEMENT.REQUIRED_BADGE' | translate }}</span>
    </label>
    <input id="packageNameDialogInput" type="text" [(ngModel)]="packageName"
        [maxlength]="maxPackageNameLength" cdkFocusInitial
        (keyup.enter)="onConfirm()"
        [placeholder]="'PACKAGES_PERSO_MANAGEMENT.PACKAGE_NAME_DIALOG_PLACEHOLDER' | translate"
        class="w-full p-2.5 rounded bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-rougeNovo" />

    <div class="flex gap-3 mt-6">
        <button type="button" (click)="onCancel()"
            class="flex-1 px-4 py-3 rounded-lg border border-gray-500 text-white font-medium hover:bg-white/5 transition-colors">
            {{ 'PACKAGES_PERSO_MANAGEMENT.BUTTON_CANCEL' | translate }}
        </button>
        <button type="button" (click)="onConfirm()" [disabled]="isConfirmDisabled"
            class="flex-1 px-4 py-3 rounded-lg bg-rougeNovo text-white font-semibold hover:bg-rougeNovoHover transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
            {{ 'PACKAGES_PERSO_MANAGEMENT.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>
